import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

import { PropertyType } from '@/features/accommodation/types/ws/websocket-message';

import { AccommodationDetailsSearchData } from '../config/accommodation-details-search-schema';

const initialState: AccommodationDetailsSearchData = {
  bookingType: 'your-tour',
  regionId: '',
  regionName: '',
  cityId: '',
  cityName: '',
  timeZone: '',
  adults: 0,
  childAges: [],
  arrivalDate: '',
  departureDate: '',
  accommodationId: '',
  apartmentId: '',
  propertyType: PropertyType.hotel,
};

type AccommodationStore = {
  formData: AccommodationDetailsSearchData;
  setFormData: (data: Partial<AccommodationDetailsSearchData>) => void;
  resetForm: () => void;
};

export const useAccommodationStore = create<AccommodationStore>()(
  devtools(
    persist(
      (set) => ({
        formData: initialState,
        setFormData: (data) =>
          set(
            (state) => ({
              formData: {
                ...state.formData,
                ...data,
              },
            }),
            false,
            'setFormData',
          ),
        resetForm: () => set({ formData: initialState }, false, 'resetForm'),
      }),
      {
        name: 'accommodation-store',
      },
    ),
  ),
);
